import VehicleTaskForm from './VehicleTaskForm';

/** IAD — Vehicle insurance (settlement) */
export default function Frame47() {
  return <VehicleTaskForm taskKind="insurance" />;
}
